import { render, staticRenderFns } from "./healthMall.vue?vue&type=template&id=aacf3958&scoped=true"
import script from "./healthMall.vue?vue&type=script&lang=js"
export * from "./healthMall.vue?vue&type=script&lang=js"
import style0 from "./healthMall.vue?vue&type=style&index=0&id=aacf3958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacf3958",
  null
  
)

export default component.exports